<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <div class="flex flex-col gap-4 bg-white p-4 rounded-xl">
    <div
      class="flex gap-2 w-full bg-white items-center"
      [formGroup]="searchForm"
    >
      <img src="../../assets/image/search.svg" alt="" class="" />

      <input   formControlName="search"
        placeholder="Search Order ID Here..."
        (keyup)="onKeyUp($event)"
        class="w-full border p-2 rounded-md outline-none"
      />
      <span>From:</span>
      <div class="flex gap-2 border p-2 rounded-xl">
        <input
          type="date"
          placeholder="from"
          class="outline-none"
          [max]="cValue"
          formControlName="startDate"
        />
      </div>
      <span>To:</span>
      <div class="flex gap-2 border p-2 rounded-xl">
        <input
          type="date"
          placeholder="from"
          class="outline-none"
        
          [min]="searchForm.controls['startDate'].value"
          formControlName="endDate"
        />
      </div>
      <app-primary-button (click)="searchApiLogs()"
      >Search</app-primary-button
    >
      <!-- <select class="w-80 border p-2 rounded-xl">
        <option>Agent ID</option>
        <option>Parent ID</option>
      </select> -->
    </div>
  </div>
  <div
    class="w-full bg-white p-4 rounded-xl flex flex-col px-4 overflow-auto "
  >
  <table class="w-[100%] text-left h-full overflow-auto">
    <tr class="h-8">
      <th class="px-4 mx-5 text-nowrap">Order Id</th>
      <th class="px-4 mx-5 text-nowrap">Amount</th>
      <th class="px-4 mx-5 text-nowrap">Balance</th>
      <th class="px-4 mx-5 text-nowrap">Customer</th>
      <th class="px-4 mx-5 text-nowrap">Error</th>
      <th class="px-4 mx-5 text-nowrap">Status</th>
      <th class="px-4 mx-5 text-nowrap">Date & Time</th>
      <th class="px-4 mx-5 text-nowrap">Txn Type</th>
      <th class="px-4 mx-5 text-nowrap">Mop Type</th>
      <th class="px-4 mx-5 text-nowrap">Payment Method</th>
    </tr>
    <tr
      *ngFor="let item of callbackLogsTable; let i = index"
      class="h-8 text-left overflow-x-auto"
      [ngStyle]="{
        backgroundColor:
          i % 2 == 0
            ? 'color-mix(in oklch,var(--primary) 10%,transparent)'
            : 'white'
      }"
    >
      <td class="px-4 mx-5 text-nowrap">
        {{ item.ORDERID ? item.ORDERID : "-" }}
      </td>
      <td class="px-4 mx-5 text-nowrap">
      {{ item.AMOUNT ? item.AMOUNT.toFixed(2) : "-" }}
      </td>
      <td class="px-4 mx-5 text-nowrap">
        {{ item.BALANCE ? item.BALANCE : "-" }}
      </td>
      <td class="px-4 mx-5 text-nowrap">
        {{ item.CUST_NAME ? item.CUST_NAME : "-" }}
      </td>
      <td class="px-4 mx-5 text-nowrap">
        {{ item.ERRORMSG ? item.ERRORMSG : "-" }}
      </td>
      <td class="px-4 mx-5 text-nowrap">
        {{ item.STATUS ? item.STATUS : "-" }}
      </td>
      <td class="px-4 mx-5 text-nowrap">
        {{
          item.CREATEDAT
            ? (item.CREATEDAT | date : "dd/MM/yyyy, h:mm a")
            : "-"
        }}
      </td>

      <td class="px-4 mx-5 text-nowrap">
        {{ item.MODEL ? item.MODEL : "-" }}
      </td>
      <td class="px-4 mx-5 text-nowrap">
        {{ item.MOPTYPE ? item.MOPTYPE : "-" }}
      </td>
      <td class="px-4 mx-5 text-nowrap">
        {{ item.TXNTYPE ? item.TXNTYPE : "-" }}
      </td>
     
    </tr>
  </table>
    <app-empty-data
    *ngIf="callbackLogsTable?.length < 1"
    class="justify-center align-items-center"
    [imageSource]="'../../assets/blankScreen/support.png'"
    [message]="'No data available'"
  ></app-empty-data>

  </div>
  <app-next-preview-button 
  [limit]="pagination.limit"
  [currentPage]="pagination.currentPage"
  [totalPage]="totalPage"
  [totalRecords]="totalRecords"
  (next)="nextPage()"
  (previous)="previousPage()"
  (pageChange)="onPageChange($event)"
  (last)="onLast()"
  (first)="onFirst()"
></app-next-preview-button>
</div>
